import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=1010c42e&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=1010c42e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1010c42e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1010c42e')) {
      api.createRecord('1010c42e', component.options)
    } else {
      api.reload('1010c42e', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=1010c42e&scoped=true&", function () {
      api.rerender('1010c42e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2o6g5fINOb4IB/JS/comp/SearchFilterTokens.vue"
export default component.exports